<template>
  <b-card header-tag="header" no-body class="mb-0">
    <template v-slot:header v-if="!noHeader">
      <b-row align-v="center">
        <b-col v-if="title" :cols="hasSearch ? 'auto' : ''">
          <strong>{{ title }}</strong>
        </b-col>
        <b-col v-if="hasSearch">
          <!-- FIGURE: 2 -->
          <div class="input-group input-group-flush">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fe fe-search"></i>
              </span>
            </div>
            <input
              v-model="filter"
              class="form-control list-search"
              type="search"
              placeholder="Search"
            />
          </div>
        </b-col>
        <b-col cols="auto" v-if="hasPagination">
          <b-row align-v="center">
            <b-col>
              <!-- FIGURE: 1 -->
              {{ indexNumber }} - {{ indexLast }} of {{ rows }}
            </b-col>
            <b-col cols="auto">
              <b-pagination
                v-model="currentPage"
                :per-page="itemPerPage"
                :total-rows="rows"
                limit="1"
                hide-goto-end-buttons
                @click.native="pageChange(currentPage)"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </template>
    <!-- sort-icon-left -->
    <b-table
      v-if="view == 'list'"
      ref="selectableTable"
      responsive
      select-mode="single"
      :selectable="isSelectable"
      :sticky-header="scrollable ? scrollHeight : false"
      :fields="tableHeader"
      :items="tableItem"
      :filter="hasSearch ? filter : ''"
      :filter-included-fields="filterOn"
      :current-page="hasPagination ? currentPage : ''"
      :per-page="hasPagination ? itemPerPage : ''"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @row-selected="onRowSelected"
      class="table-sm table-nowrap card-table"
    >
      <template v-slot:head(value)>
        <!-- FIGURE: 3 -->
        <b-form-checkbox
          v-model="selectAll"
          ref="checkAll"
          @change="checkAll()"
        >
        </b-form-checkbox>
      </template>
      <template v-slot:cell(value)="data">
        <!-- FIGURE: 3 -->
        <b-form-checkbox v-model="selected" :value="data.value">
        </b-form-checkbox>
      </template>
      <template
        v-if="this.$route.name == 'patient-profile'"
        v-slot:cell(status)="data"
      >
        <b-badge
          style="padding: 5px; display: inline-block"
          :class="[
            'mr-2',
            data.value == 'In Progress'
              ? 'badge-warning'
              : data.value == 'Completed'
              ? 'badge-success'
              : data.value == 'Cancelled'
              ? 'badge-danger'
              : '',
          ]"
        ></b-badge>
        {{ data.value }}
      </template>
      <template v-if="this.$route.name == 'patients'" v-slot:cell(name)="data">
        <b-avatar :src="data.value.img"></b-avatar>
        <span class="ml-3">{{ data.value.fullName }}</span>
      </template>
      <template
        v-if="this.$route.name == 'patients'"
        v-slot:cell(action)="data"
      >
        <router-link
          :to="`/patients/${data.value
            .replace(/[^a-z]+/i, '-')
            .toLowerCase()}/${data.item.name.fullName
            .replace(/[^a-z]+/i, '-')
            .toLowerCase()}`"
          custom
          v-slot="{ navigate }"
        >
          <a href="javascript:void(0)" @click="navigate">
            {{ data.value == "profile" ? "View Profile" : data.value }}
          </a>
        </router-link>
      </template>
      <template v-slot:cell(link)="data">
        <router-link
          :to="`/verification/${data.item.name
            .replace(/[^a-z]+/i, '-')
            .toLowerCase()}`"
          custom
          v-slot="{ navigate }"
        >
          <a href="javascript:void(0)" @click="navigate">
            {{ data.value }}
          </a>

          <!-- Just to ready once the changes was approved this comment section will be the one to used -->
          <!-- {{
						data.value == 'Verify ID' ? 'Verify ID' :
						data.value == 'Message' ? 'Message' : 
						data.value == 'Prescibe' ? 'Prescibe' :
						data.value
					}} -->
        </router-link>
      </template>
    </b-table>
    <div v-if="view == 'grid'">
      <b-container fluid v-if="tableItem.length" class="pt-4">
        <b-row>
          <b-col cols="12">
            <b-row align-v="center" class="mb-3" style="margin-top: -15px">
              <b-col cols="auto">
                <b-form-checkbox
                  v-model="selectAll"
                  @change="checkAll()"
                  ref="checkAll"
                  >Move to:</b-form-checkbox
                >
              </b-col>
              <b-col cols="auto">
                <b-button variant="link">In Progress</b-button>
              </b-col>
              <b-col cols="auto">
                <b-button variant="link">Completed</b-button>
              </b-col>
              <b-col cols="auto">
                <b-button variant="link">Archive</b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            cols="12"
            sm="6"
            lg="6"
            xl="3"
            v-for="(item, i) in resultQuery"
            :key="i"
          >
            <label :for="'checkbox-' + i" class="checkbox">
              <b-card class="grid">
                <b-row>
                  <b-col cols="auto" class="pr-0">
                    <b-avatar :src="item.name.img" size="50px"></b-avatar>
                  </b-col>
                  <b-col>
                    <h4 class="mb-0">{{ item.name.fullName }}</h4>
                    <small class="text-muted d-block">{{
                      item.treatment
                    }}</small>
                    <small class="text-muted d-block">{{
                      item.medication
                    }}</small>
                    <small class="text-muted d-block">{{
                      item.phoneNumber
                    }}</small>
                  </b-col>
                  <b-col cols="auto">
                    <b-form-checkbox
                      :id="'checkbox-' + i"
                      v-model="selected"
                      :value="item.value"
                      class="c-checkbox"
                    >
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                <b-row align-v="center" align-h="center" class="mt-3">
                  <b-col class="text-center">
                    <router-link
                      :to="`/patients/${item.action
                        .replace(/[^a-z]+/i, '-')
                        .toLowerCase()}/${item.name.fullName
                        .replace(/[^a-z]+/i, '-')
                        .toLowerCase()}`"
                      custom
                      v-slot="{ navigate }"
                    >
                      <a href="javascript:void(0)" @click="navigate">{{
                        "View Profile"
                      }}</a>
                    </router-link>
                    <!-- <b-button variant="link" @click="viewProfile">
											{{ item.action = 'View Profile' }}
										</b-button> -->
                  </b-col>
                </b-row>
              </b-card>
            </label>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    view: {
      type: String,
      default: "list",
      validator(x) {
        return ["list", "grid"].includes(x);
      },
    },
    tableHeader: {
      type: Array,
      default: () => [],
    },
    tableItem: {
      type: Array,
      default: () => [],
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    scrollHeight: {
      type: String,
      default: "400px",
    },
    hasPagination: {
      type: Boolean,
      default: false,
    },
    hasSearch: {
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
    itemPerPage: {
      type: Number,
      default: 5,
    },
    noHeader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      indexLast: 0, // see FIGURE: 1
      indexNumber: 0, // see FIGURE: 1
      filter: null, // see FIGURE: 2
      filterOn: [],
      selected: [], // see FIGURE: 3
      rowSelect: [],
      selectAll: false,
    };
  },
  mounted() {
    // see FIGURE: 1
    this.indexNumber = (this.currentPage - 1) * this.itemPerPage + 1;
    this.indexLast = this.indexNumber - 1 + this.itemPerPage;

    // display total item see FIGURE: 1 also
    this.rows = this.tableItem.length;
    // if indexLast is greater than row then display the remaining row
    if (this.indexLast > this.rows) this.indexLast = this.rows;
  },
  methods: {
    onRowSelected(rows) {
      this.rowSelect = rows;
    },
    checkAll() {
      // see FIGURE: 3
      this.selected = [];

      let itemsPerPage = this.tableItem;

      // if pagination is true
      if (this.hasPagination)
        itemsPerPage = this.tableItem.slice(
          this.indexNumber - 1,
          this.indexLast
        );

      if (!this.selectAll)
        itemsPerPage.forEach((item) => {
          this.selected.push(item.value);
        });
    },
    pageChange(currentPage) {
      // see FIGURE: 1
      // paginate list view
      this.indexNumber = (currentPage - 1) * this.itemPerPage + 1;
      this.indexLast = this.indexNumber - 1 + this.itemPerPage;

      // if pagination is true
      if (this.hasPagination)
        this.selectAll =
          this.selected.length == this.indexLast
            ? true
            : this.indexLast > this.rows
            ? false
            : false;

      if (this.indexLast > this.rows) this.indexLast = this.rows;
    },

    gridPaginate(items) {
      // paginate grid view
      let page = this.currentPage,
        perPage = this.itemPerPage,
        from = page * perPage - perPage,
        to = page * perPage;

      return items.slice(from, to);
    },
    // see FIGURE: 2
    searchTerm(value) {
      return this.filter
        .toLowerCase()
        .split(" ")
        .every((v) => value.toString().toLowerCase().includes(v));
      // return this.filter.toLowerCase().split(' ').every(v => this.tableItem.title.toLowerCase().includes(v));
    },
  },
  computed: {
    // see FIGURE: 2
    resultQuery() {
      if (this.filter) {
        return this.tableItem.filter((item) => {
          const patient = item.name && item.name.fullName,
            treatment = item.treatment,
            medication = item.medication;

          return (
            this.searchTerm(patient) ||
            this.searchTerm(treatment) ||
            this.searchTerm(medication)
          );
        });
      }

      if (this.hasPagination) return this.gridPaginate(this.tableItem);
      return this.tableItem;
    },
    // selectAll: {
    // 	// check all boxes see also FIGURE: 3
    // 	get: function () {
    // 		return this.tableItem ? this.selected.length == this.tableItem.length : false
    // 	},
    // 	set: function (value) {
    // 		let selected = []
    // 		let itemsPerPage = this.tableItem

    // 		if (this.hasPagination) itemsPerPage = this.tableItem.slice(this.indexNumber - 1, this.indexLast)

    // 		if (value) itemsPerPage.forEach(item => { selected.push(item.value) })
    // 		this.selected = selected
    // 	}
    // }
  },
  watch: {
    // check all boxes see also FIGURE: 3
    selected(newValue) {
      this.selectAll = newValue.length == this.rows ? true : false;
      if (this.hasPagination)
        this.selectAll = newValue.length == this.indexLast ? true : false;
    },
  },
};
</script>

<style scoped>
/deep/.pagination {
  margin-bottom: 0;
}

/deep/.page-item.active .page-link,
.page-item.active .page {
  display: none;
}

/deep/.table thead th {
  background-color: transparent;
}

/deep/.table thead th:focus {
  /* outline: 0; */
  user-select: none;
}
</style>

<style lang="scss">
.table.b-table > tbody > .table-active,
.table.b-table > tbody > .table-active > th,
.table.b-table > tbody > .table-active > td {
  background-color: $primary;
  color: $white;
}
</style>

<style lang="scss" scoped>
.checkbox {
  display: block;
  margin-bottom: 0;
}

.card-header {
  background-color: rgba(213, 228, 240, 0.15);
}

.grid {
  background-color: #f9fbfd;

  .card-body {
    padding: 10px;
  }
}
</style>
